const sanitizeForm = (form: any) => {
	if(form.cpf) form.cpf = form.cpf.replaceAll('.', '').replaceAll('-', '');
	if(form.phone) form.phone = form.phone.replaceAll('(', '').replaceAll(')', '').replaceAll('-', '').replaceAll(' ', '');
	if(form.cep) form.cep = form.cep.replaceAll('-', '');

	return form
}

export default sanitizeForm

const sanitizeField = (value: string) => {
	return value.replaceAll('.', '').replaceAll('-', '').replaceAll('(', '').replaceAll(')', '').replaceAll(' ', '');
}

export {
	sanitizeField
}